import { Card, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import Iconify from '../../../../components/Iconify';

/**
 * Compact stat card for this page.
 *
 * Deliberately local rather than a change to DashboardWidgetSummaryCard, which
 * is a tall centred card (spacing(5,0) padding, 64px icon) used by many other
 * dashboards -- shrinking it there would resize every one of them. This lays the
 * icon and figure out on one row so five cards fit without dominating the page.
 */
export default function StatCard({ title, total, icon, color = 'primary' }) {
  return (
    <Card
      sx={{
        boxShadow: 'none',
        p: 1.5,
        height: '100%',
        color: (theme) => theme.palette[color].darker,
        bgcolor: (theme) => theme.palette[color].lighter,
      }}
    >
      <Stack direction="row" alignItems="center" gap={1.5}>
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            width: 40,
            height: 40,
            flexShrink: 0,
            borderRadius: '50%',
            color: (theme) => theme.palette[color].dark,
            backgroundImage: (theme) =>
              `linear-gradient(135deg, ${alpha(theme.palette[color].dark, 0)} 0%, ${alpha(
                theme.palette[color].dark,
                0.24,
              )} 100%)`,
          }}
        >
          <Iconify icon={icon} width={20} height={20} />
        </Stack>

        <Stack sx={{ minWidth: 0 }}>
          <Typography variant="h5" sx={{ lineHeight: 1.2 }}>
            {total}
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.72, lineHeight: 1.2 }}>
            {title}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
}
